<template>
    <div
        v-if="contents[0] && contents[0].countRow > 0"
        class="bo-announcement"
    >
        <div
            class="frame"
            v-for="(content, i) in contents"
            :key="content.index"
        >
            <div class="announcement-wrapper">
                <div class="announcement-left">
                    <div class="title theme-primary-color">{{ content.title }}</div>
                    <div class="link">
                        <a
                            :href="content.link"
                            class="links theme-primary-color"
                        >
                            <span>{{ generalTranslations['view_all'] ?? 'VIEW ALL' }}</span>
                            <i class="icon-chevronright"></i>
                        </a>
                    </div>
                    <div class="announcement-nav">
                        <button class="nav-btn" @click="previous">
                            <i class="icon-chevronleft"></i>
                        </button>
                        <button class="nav-btn" @click="next">
                            <i class="icon-chevronright"></i>
                        </button>
                    </div>
                </div>
                <!-- only two no need for loop -->
                <div class="announcement-right">
                    <a
                        :href="content.link + '/' + content.details[currentIndex].id"
                        class="announcement-item"
                        :style="{ minHeight: (rowHeights[i] || 0) + 'px' }"
                    >
                        <div class="announcement-head">
                            <div class="announcement-head-content">
                                <div class="announcement-date m-0">
                                    {{ formatDate(content.details[currentIndex].created_at) }}
                                </div>

                                <div class="announcement-title m-0">
                                    {{ content.details[currentIndex].title }}
                                </div>
                            </div>
                            <i class="icon-pin"></i>
                        </div>
                        <div
                            class="announcement-content"
                            v-html="content.details[currentIndex].content"
                        ></div>
                        <div
                            v-if="content.details[currentIndex].thumbnail?.source_url"
                            class="announcement-banner"
                        >
                            <img
                                :src="content.details[currentIndex].thumbnail.source_url"
                                alt="Announcement banner"
                            />
                        </div>
                    </a>
                    <a
                        v-if="content.details[currentIndex+1]"
                        :href="content.link + '/' + content.details[currentIndex+1].id"
                        class="announcement-item"
                        :style="{ minHeight: (rowHeights[i] || 0) + 'px' }"
                    >
                        <div class="announcement-head">
                            <div class="announcement-head-content">
                                <div class="announcement-date m-0">
                                    {{ formatDate(content.details[currentIndex+1].created_at) }}
                                </div>

                                <div class="announcement-title m-0">
                                    {{ content.details[currentIndex+1].title }}
                                </div>
                            </div>
                            <i class="icon-pin"></i>
                        </div>
                        <div
                            class="announcement-content"
                            v-html="content.details[currentIndex+1].content"
                        ></div>
                        <div
                            v-if="content.details[currentIndex+1].thumbnail?.source_url"
                            class="announcement-banner"
                        >
                            <img
                                :src="content.details[currentIndex+1].thumbnail.source_url"
                                alt="Announcement banner"
                            />
                        </div>
                    </a>
                    <div class="height-measure" ref="measureContainer" v-show="isMeasuring">
                        <a
                            v-for="(item, index) in content.details"
                            :key="'measure-' + index"
                            class="announcement-item"
                        >
                            <div class="announcement-head">
                                <div class="announcement-head-content">
                                    <div class="announcement-date m-0">
                                        {{ formatDate(item.created_at) }}
                                    </div>

                                    <div class="announcement-title m-0">
                                        {{ item.title }}
                                    </div>
                                </div>
                                <i class="icon-pin"></i>
                            </div>
                            <div
                                class="announcement-content"
                                v-html="item.content"
                            ></div>
                            <div
                                v-if="item.thumbnail?.source_url"
                                class="announcement-banner"
                            >
                                <img
                                    :src="item.thumbnail.source_url"
                                    alt="Announcement banner"
                                    @load="calculateMaxHeight"
                                />
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import httpMixin from "@/v2/mixins/http.js";
import { returnPopupMixin } from "@/v2/mixins/bo-return-popup.js";

export default {
    mixins: [returnPopupMixin, httpMixin],

    props: {
        title: {
            type: String,
            default: "",
        },
        contents: {
            type: Array,
            default: [],
        },
    },

    data() {
        return {
            generalTranslations: window.bo.generalTranslations,
            currentIndex: 0,
            rowHeights: [],
            isMeasuring: false,
        };
    },

    mounted() {
        this.$nextTick(this.calculateMaxHeight);
        window.addEventListener("scroll", this.handleScroll);
    },

    watch: {
        contents: {
            handler() {
                this.$nextTick(this.calculateMaxHeight);
            },
            deep: true,
        },
    },

    methods: {
        calculateMaxHeight() {
            this.isMeasuring = true;
            this.$nextTick(() => {
                if (!this.$refs.measureContainer) {
                    this.isMeasuring = false;
                    return;
                }

                const containers = Array.isArray(this.$refs.measureContainer)
                    ? this.$refs.measureContainer
                    : [this.$refs.measureContainer];

                containers.forEach((container, index) => {
                    if (!container) return;

                    let max = 0;
                    const items = container.querySelectorAll('.announcement-item');
                    for (let el of items) {
                        max = Math.max(max, el.offsetHeight);
                    }

                    this.$set(this.rowHeights, index, max);
                });
                this.isMeasuring = false;
            });
        },
        previous() {
            if (this.currentIndex <= 0) {
                return;
            }
            this.currentIndex--;
        },
        next() {
            if ((this.currentIndex + 1) >= (this.contents[0].countRow - 1)) {
                return;
            }
            this.currentIndex++;
        },
        formatDate(dateStr) {
            if (!dateStr) return '';

            const date = new Date(dateStr);

            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();

            let hours = date.getHours();
            const minutes = date.getMinutes().toString().padStart(2, '0');
            const ampm = hours >= 12 ? 'pm' : 'am';
            let translatedAmpm = this.generalTranslations[ampm] ?? ampm;
            hours = hours % 12 || 12;

            return `${day}/${month}/${year}, ${hours}:${minutes}${translatedAmpm}`;
        },
    },
};
</script>
